/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React from "react";
import Button from "../../button";

// Interface for ErrorScreen Props
interface ErrorScreenProps {
  errorMainClassName?: string;
  errorTitle?: string;
  errorDetails?: string;
  errorBtnName?: any;
  withBtn?: boolean;
  handleErrorBtn?: () => void;
}
// Interface for ErrorScreen State
interface ErrorScreenState {}

/**
 * Error Screen component
 *
 * @namespace ErrorScreen
 */
class ErrorScreen extends React.Component<ErrorScreenProps, ErrorScreenState> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  /**
   * This method is used for handle button click
   * @param {any} event
   *
   */
  handleError = () => {
    if (this.props.handleErrorBtn) {
      this.props.handleErrorBtn();
    }
  };

  render() {
    const {
      errorBtnName,
      errorDetails,
      errorMainClassName,
      errorTitle,
      withBtn,
    } = this.props;
    return (
      <>
        <div
          className={
            errorMainClassName || "error-screen-container align-middle"
          }
        >
          <div className="error-screen-wrapper">
            <div className="error-middle-area">
              <div className="title">{errorTitle || ""}</div>
              <div className="sub-title">{errorDetails || ""}</div>
              {withBtn ? (
                <Button
                  onButtonClick={() => this.handleError()}
                  name={errorBtnName}
                  className={"app-btn border-btn"}
                />
              ) : null}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default ErrorScreen;
